import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { Region, RegionsState } from "./types";

const initialState: RegionsState = {
  data: [],
  loading: false,
  error: null,
  currentRegion: undefined,
};

export const fetchRegionsDataAsync = createAsyncThunk(
  "regions/fetchRegionsData",
  async () => await api.getRegions()
);

const regionsSlice = createSlice({
  name: "regions",
  initialState,
  reducers: {
    setCurrentRegion: (state, action: PayloadAction<Region | undefined>) => {
      state.currentRegion = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegionsDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegionsDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRegionsDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch regions data";
      });
  },
});

export const { setCurrentRegion } = regionsSlice.actions;

export default regionsSlice.reducer;
